import BlogPostThumbnailsContainer from "./BlogPostThumbnailsContainer";
export default BlogPostThumbnailsContainer;
